"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var classnames_1 = require("classnames");
var styles = require("./index.module.css");
var ImageFont = /** @class */function (_super) {
  __extends(ImageFont, _super);
  function ImageFont() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  ImageFont.prototype.render = function () {
    var _a = this.props,
      glyphInfos = _a.glyphInfos,
      imageClassName = _a.imageClassName,
      children = _a.children;
    return React.createElement.apply(React, __spreadArray([React.Fragment, {}], children.split('').map(function (char) {
      return glyphInfos[char] ? React.createElement(ImageChar, {
        className: imageClassName,
        char: char,
        info: glyphInfos[char]
      }) : char;
    }), false));
  };
  return ImageFont;
}(React.PureComponent);
exports.default = ImageFont;
var ImageChar = /** @class */function (_super) {
  __extends(ImageChar, _super);
  function ImageChar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      image: null
    };
    return _this;
  }
  ImageChar.cacheImage = function (src) {
    if (!ImageChar.cachedImages[src]) {
      ImageChar.cachedImages[src] = {
        image: new Promise(function (resolve) {
          var image = new Image();
          image.src = src;
          if (image.complete) resolve(image);else image.onload = function () {
            return resolve(image);
          };
        }),
        count: 0
      };
    }
    ++ImageChar.cachedImages[src].count;
  };
  ImageChar.decacheImage = function (src) {
    --ImageChar.cachedImages[src].count;
    if (ImageChar.cachedImages[src].count <= 0) {
      delete ImageChar.cachedImages[src];
    }
  };
  ImageChar.prototype.setImage = function () {
    return __awaiter(this, void 0, void 0, function () {
      var _a;
      var _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _a = this.setState;
            _b = {};
            return [4 /*yield*/, ImageChar.cachedImages[this.props.info.src].image];
          case 1:
            _a.apply(this, [(_b.image = _c.sent(), _b)]);
            return [2 /*return*/];
        }
      });
    });
  };

  ImageChar.prototype.componentDidMount = function () {
    ImageChar.cacheImage(this.props.info.src);
    this.setImage();
  };
  ImageChar.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.info.src === this.props.info.src) return;
    ImageChar.decacheImage(prevProps.info.src);
    ImageChar.cacheImage(this.props.info.src);
    this.setImage();
  };
  ImageChar.prototype.componentWillUnmount = function () {
    ImageChar.decacheImage(this.props.info.src);
  };
  ImageChar.prototype.render = function () {
    var image = this.state.image;
    var _a = this.props,
      char = _a.char,
      className = _a.className;
    if (!image) {
      return React.createElement("span", {
        className: className
      }, char);
    }
    var _b = this.props.info,
      _c = _b.x,
      x = _c === void 0 ? 0 : _c,
      _d = _b.y,
      y = _d === void 0 ? 0 : _d,
      _e = _b.w,
      w = _e === void 0 ? image.naturalWidth : _e,
      _f = _b.h,
      h = _f === void 0 ? image.naturalHeight : _f,
      glyphClassName = _b.className,
      style = _b.style;
    return React.createElement("svg", {
      className: (0, classnames_1.default)(styles.imageFontChar, className, glyphClassName),
      style: style,
      viewBox: "0 0 ".concat(w, " ").concat(h),
      "aria-label": char
    }, React.createElement("image", {
      xlinkHref: image.src,
      x: -x,
      y: -y,
      width: image.naturalWidth,
      height: image.naturalHeight
    }));
  };
  ImageChar.cachedImages = {};
  return ImageChar;
}(React.Component);